<template>
  <div>
    <a-modal
      title="管理员登陆日志"
      :maskClosable="false"
      v-model="visible"
      :footer="null"
      width="1000px"
    >
      <data-table ref="dataTable" :option="option" class="dataTable">
      </data-table>
    </a-modal>
    <a-modal
      centered
      title="查看详情"
      :maskClosable="false"
      v-model="detailVisible"
      :footer="null"
    >
      <div v-html="details"></div>
    </a-modal>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import moment from "moment";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      detailVisible: false,
      visible: false,
      details: "",
      ModuleNameChange: "",
      DateBegin: "",
      DateEnd: "",
      Detail: "",
      option: {}
    };
  },
  created() {
    this.option = {
      headSearch: {
        content: [
          {
            label: "日期范围",
            name: "dateRange",
            type: "date-range-picker",
            colnum: 2
          }
        ],
        onSubmitBefore: values => {
          const json = {
            ...values
          };
          if (!values.dateRange[0] || !values.dateRange[1]) {
            this.$message.error("请选择日期范围");
            return false;
          }
          if (values.dateRange) {
            json.startDate =
              values.dateRange[0] !== null
                ? moment(values.dateRange[0]).format("YYYY-MM-DD")
                : "";
          }
          if (values.dateRange && values.dateRange.length > 1) {
            json.endDate =
              values.dateRange[1] !== null
                ? moment(values.dateRange[1]).format("YYYY-MM-DD")
                : "";
          }
          return json;
        }
      },
      grid: {
        api: "QueryLoginAdminLog",
        autoLoad: false,
        props: {
          autoLoad: false,
          scroll: { x: false, y: window.document.body.clientHeight / 2 }
        },
        columns: [
          {
            title: "序号",
            width: "6%",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "登陆门店",
            width: "12%",
            dataIndex: "CompanyCode"
          },
          {
            title: "登录时间",
            width: 150,
            dataIndex: "LoginTime"
          },
          {
            title: "授权人",
            width: "12%",
            dataIndex: "AdminName"
          },
          {
            title: "内容",
            dataIndex: "Content",
            customRender: text => {
              return (
                <span title={text} class="text-hide">
                  {text}
                </span>
              );
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "12%",
            customRender: (text, record) => {
              if (text) {
                const viewDetails = {
                  click: () => {
                    this.viewDetails(record);
                  }
                };
                return (
                  <a-button size="small" type="link" {...{ on: viewDetails }}>
                    查看
                  </a-button>
                );
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    onShow() {
      this.visible = true;
      this.$nextTick(() => {
        let dateRange = [moment(), moment()];
        console.log(this.$refs.dataTable.$refs.headSearchForm);
        this.$refs.dataTable.$refs.headSearchForm.setData({ dateRange });
        this.$refs.dataTable.onHeadSearchSubmit({ dateRange });
      });
    },
    viewDetails(row) {
      this.detailVisible = true;
      this.details = row.Content.replace(/\r\n/gi, "<br/>");
    }
  }
};
</script>

<style lang="less" scoped>
.dataTable {
  min-height: 50vh !important;
  height: 50vh;
}

.text-hide {
  display: inline-block;
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
